import moment from "moment";
import { Component, Show } from "solid-js";

type Props = { value: string; format?: string;}
export const DateTime : Component<Props> = (props) => <Show when={props.value}>{moment(props.value).format(props.format || "YYYY-MM-DD h:mm:ss A")}</Show>;